module.exports = __webpack_public_path__ + "img/head-friendly.365bb3bc.png";